package pl.decks.chartjs.radar.options.plugins

import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption

data class RadarPluginOptions(
    val legend: LegendOptions? = null,
    val tooltip: TooltipOptions? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        if (legend != null) this.legend = legend.toChartJs()
        if (tooltip != null) this.tooltip = tooltip.toChartJs()
    }
}
